import AddTeamMemberModal from './components/Modals/AddWorkspaceUser/AddWorkspaceUser.component';
import DeleteUserConfirmation from './components/Modals/DeleteUser/DeleteUserModal.component';
import ManageWorkspaceUser from './components/Modals/EditUser/EditUser.component';
import EditUserConfirm from './components/Modals/EditUser/EditUserConfirm.component';
import UserAdded from './components/Modals/UserAdded.component';
import DeleteUserModal from './components/Modals/UserCreatedConfirmation.component';
import UserCreatedConfirmationV2 from './components/Modals/UserCreatedConfirmationV2.component';
import { TeamContext } from './Team.context';
import useTeam from './Team.hook';
import { tTeamProvider } from './Team.types';

export default function TeamProvider(props: tTeamProvider): React.ReactElement {
  const { children } = props;
  const teamData = useTeam();

  return (
    <TeamContext.Provider value={teamData}>
      {children}
      {teamData.addTeamMemberModalIsOpen && <AddTeamMemberModal />}
      {teamData.showDeleteModal && <DeleteUserConfirmation />}
      {teamData.showEditUserModal && <ManageWorkspaceUser />}
      {teamData.showUserCreatedModal && <DeleteUserModal />}
      {teamData.showExistentUserModal && <UserAdded />}
      {teamData.showConfirmEditUserModal && <EditUserConfirm />}
      {teamData.toggleUserCreatedModalV2 && <UserCreatedConfirmationV2 />}
    </TeamContext.Provider>
  );
}
